import { lazy } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import pendingInvoices from './pendingInvoices';

const NotFoundPage = lazy(() => import('../../pages').then(module => ({ default: module.NotFound })));
const WithholdingDetailPage = lazy(() => import('../../pages').then(module => ({ default: module.WithholdingDetail })));
const BalanceDetailPage = lazy(() => import('../../pages').then(module => ({ default: module.BalanceDetail })));

const currentAccountRoutes = {
  path: '/cuenta-corriente',
  element: <Outlet />,
  errorElement: <NotFoundPage />,
  children: [
    pendingInvoices,

    {
      path: '',
      element: <Navigate to='/cuenta-corriente/facturas-pendientes' />,
    },
    {
      path: 'detalle-retenciones',
      element: <WithholdingDetailPage title="Detalle de Retenciones" />,
    },
    {
      path: 'saldo-cuenta-corriente',
      element: <BalanceDetailPage title="Saldo de Cuenta Corriente" />,
    },
  ],
};

export default currentAccountRoutes;
